var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"property-price-detail"},[_c('Price',{attrs:{"is-sold":_vm.isSold,"price":_vm.price,"display-is-sold":_vm.displayIsSold}}),_c('p',{staticClass:"property-square-meter-price"},[_vm._v(" "+_vm._s(_vm.$n(this.surface, "surface", "fr-FR"))+" m² soit "+_vm._s(_vm.$n(_vm.pricePerSquareMeter, "currency", "fr-FR"))+" / m² ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }